module.exports = __webpack_public_path__ + "static/media/logo.c3b8c650.svg";